import { useTripBuilder } from "./TripBuilderContext";

export const useShowMarketingMessageView = () => {
    const { gcDeparture, departure } = useTripBuilder();

    const isMarketingView =
        gcDeparture?.micrositeContent?.tripBuilderMarketingTitle ||
        gcDeparture?.micrositeContent?.tripBuilderMarketingBody;

    return !!(isMarketingView && departure?.status);
};
